import React from "react";

const DocumentGeneratorCTX = React.createContext({
  documentType: "",
  dataset: {},
  didSubmitGenerateBtn: false,
  printGeneratedContent: undefined,
  pagesStartFrom: 0,
  selectedYear: "",
  selectedMonth: "",
});

export default DocumentGeneratorCTX;
